import { Button, Col, Form, Modal, Row } from "antd";
import { useTranslation } from "react-i18next";

export default function ModalDelete({ open, onCancel, onDelete, loading }) {
  const [form] = Form.useForm();

  const { t } = useTranslation()
  
  const onFinish = () => {
      onDelete();
  };

  return (
    <Modal
      open={open}
      title={t('deleteNotification')}
      centered
      footer={null}
      onCancel={onCancel}
      width={400}
      destroyOnClose
    >
      <Form form={form} onFinish={onFinish} layout="vertical">
        <h2 style={{ color: 'red' }}>{t('sureToDelete')}</h2>
        <Row gutter={16}>
          <Col span={8} offset={4}>
            <Form.Item>
              <Button loading={loading} danger style={{ width: "100%" }} htmlType="submit">
                Ok
              </Button>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Button loading={loading} style={{ width: "100%" }} onClick={onCancel}>
              {t('cancel')}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
